module.exports = __webpack_public_path__ + "static/media/icon-new.bb07ccb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/type-filters/icon-new.svg
// module id = 531
// module chunks = 0